import { Container, ContainerItem } from '../common/container/Container'
import { DownloadRegisterProps } from '../modules/downloadsRegister/container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { DOWNLOADSREGISTER_API_KEY, DOWNLOADSREGISTER_SERVICE_KEY, DOWNLOADSREGISTER_MODULE } from '../modules/downloadsRegister'
import { DownloadsRegisterService } from '../modules/downloadsRegister/services/DownloadsRegister'
import { DownloadsRegisterApi } from '../modules/downloadsRegister/api/DownloadsRegister'

let container: Container

function init(p: DownloadRegisterProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(DOWNLOADSREGISTER_API_KEY, new ContainerItem({ instance: new DownloadsRegisterApi() }))
  items.set(
    DOWNLOADSREGISTER_SERVICE_KEY,
    new ContainerItem({
      instance: new DownloadsRegisterService({ apiKey: DOWNLOADSREGISTER_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getDownloadsRegisterContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[DOWNLOADSREGISTER_MODULE],
      },
    })
  }

  return container
}
